<template>
    <v-snackbar
        class="global-snackbar"
        :timeout="timeout"
        bottom
        right
        v-model="show"
        color='red darken-3'>
        <h5 v-if="!mobile" class="text-white">
        You are using an unsupported browser. To ensure site performance, <a href=
        "http://outdatedbrowser.com/en">click here</a> to upgrade to the latest version of your
        preferred browser. </h5>
        <h5 v-else class="text-white">
        To ensure site performance upgrade your mobile browser. </h5>
        <v-btn v-if="!mobile" color='red darken-3' depressed @click="clickButton">{{ button_text }}</v-btn>
    </v-snackbar>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: ['supported'],
        data () {
            return {
                button_text: 'No thanks',
                timeout: 10000,
                show: this.supported
            }
        },
        computed: {
            ...mapState({
                mobile: state => state.mobile.mobile
            }),
        },

        methods: {

            clickButton: async function() {
                this.show = false
            }
        }
    }
</script>